import React from "react";

const UploadImagesIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.588"
      height="18.441"
      viewBox="0 0 24.588 18.441"
    >
      <g id="db33" transform="translate(0 0)">
        <path
          id="Path_1264"
          data-name="Path 1264"
          d="M7.4,969.362a1.394,1.394,0,0,0-1.4,1.4v9.919l6.889-6.147a.546.546,0,0,1,.786.044l4.951,5.466,3.877-3.283a.559.559,0,0,1,.716-.009l3.292,2.681c.056,0,.11-.009.166-.009a4.444,4.444,0,0,1,1.118.148v-8.81a1.394,1.394,0,0,0-1.4-1.4H7.4Zm11.735,3.353a1.4,1.4,0,1,1-1.4,1.4A1.4,1.4,0,0,1,19.132,972.715Zm-5.911,3.021L6,982.181v1.432a1.394,1.394,0,0,0,1.4,1.4H22.354a4.43,4.43,0,0,1,2.742-5.291l-2.227-1.808-3.938,3.326a.559.559,0,0,1-.768-.044Zm13.455,4.243a3.912,3.912,0,1,0,3.912,3.912A3.912,3.912,0,0,0,26.676,979.979Zm0,1.4a.548.548,0,0,1,.4.183c.465.415.924.932,1.388,1.38a.548.548,0,0,1,0,.786.553.553,0,0,1-.786,0l-.445-.446v2.567a.559.559,0,1,1-1.118,0v-2.567l-.445.445a.556.556,0,1,1-.786-.786c.455-.457.931-.957,1.388-1.38a.547.547,0,0,1,.4-.183Z"
          transform="translate(-6 -969.362)"
          fill={fill ? fill : "#707070"}
        />
      </g>
    </svg>
  );
};

export default UploadImagesIcon;
